import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import PIProposalBuilder from "@/pages/PIProposalBuilder";
export const Route = createFileRoute("/pi-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="private-investigation"><PIProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
